import React from 'react'
import translate from 'core/translate'
import styles from './preview__notSupport.jcss'

const PreviewNotSupport = () => {
    return <div className={styles.wrapper}>{translate('fileTypeNotSupport')}</div>
}

export default PreviewNotSupport
